<template>
  <div id="app" class="v-flex">
    <ContainerWithNav>
      <StartupLoadError v-if="hasStartupLoadError" />
      <router-view v-else-if="isInfoStored" />
    </ContainerWithNav>
    <InactiveNotice />
  </div>
</template>

<script>
import ContainerWithNav from '@/components/PageContainers/ContainerWithNav/ContainerWithNav.vue'
import InactiveNotice from '@/components/Authentication/InactiveNotice/InactiveNotice.vue'
import StartupLoadError from '@/components/Authentication/StartupLoadError/StartupLoadError.vue'
import { debounce } from 'lodash-es'

export default {
  components: {
    ContainerWithNav,
    InactiveNotice,
    StartupLoadError
  },

  data() {
    return {
      activityHandler: null,
      activityEvents: [],
      boundVisibilityHandler: null
    }
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },

    hasStartupLoadError() {
      return (
        !this.$route.meta?.publicRoute &&
        this.$store.getters.isAuthenticated &&
        this.$store.state.dataStore.startupLoadError != null
      )
    },

    isInfoStored() {
      if (this.$route.meta?.publicRoute) {
        return true
      }
      if (this.$store.getters.isAuthenticated) {
        return (
          this.$store.state.dataStore.isRefreshComplete ||
          this.$store.getters.currentMerchant != null
        )
      } else {
        return true
      }
    }
  },

  watch: {
    // Every logout path, not only the error screen's Sign out: a stale error would otherwise
    // replace the router view after the next sign-in.
    isAuthenticated(isAuthenticated) {
      if (!isAuthenticated) {
        this.$store.commit('setStartupLoadError', null)
      }
    }
  },

  created() {
    this.$store.dispatch('heartbeat')

    this.activityHandler = debounce(() => {
      if (!this.$store.getters.isAuthenticated) {
        return
      }

      if (this.$store.getters.isInactive) {
        this.$store.dispatch('continueSession')
      } else {
        this.$store.commit('setLastActivity')
      }
    }, 60000)

    this.activityEvents = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'click'
    ]

    this.activityEvents.forEach(event =>
      window.addEventListener(event, this.activityHandler, { passive: true })
    )

    this.boundVisibilityHandler = this.visibilityHandler.bind(this)
    document.addEventListener('visibilitychange', this.boundVisibilityHandler)
  },

  beforeDestroy() {
    if (this.activityEvents && this.activityHandler) {
      this.activityEvents.forEach(event =>
        window.removeEventListener(event, this.activityHandler)
      )
    }
    document.removeEventListener(
      'visibilitychange',
      this.boundVisibilityHandler
    )
  },

  methods: {
    visibilityHandler() {
      if (document.visibilityState !== 'visible') {
        return
      }
      if (!this.$store.getters.isAuthenticated) {
        return
      }

      if (this.$store.getters.isInactive) {
        this.$store.dispatch('continueSession')
      } else {
        this.$store.commit('setLastActivity')
      }
    }
  }
}
</script>

<style lang="scss">
html,
body {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: stretch;
  overflow: auto;

  background: transparent linear-gradient(340deg, $dark-blue 0%, $blue 100%) 0%
    0% no-repeat padding-box;
}
</style>
